import { createContext, useContext, useState, useEffect } from "react";

const UnitContext = createContext(null);

export const UnitProvider = ({ children }) => {
    const [units, setUnits] = useState(() => {
        if (typeof window === "undefined") return "metric";
        return window.localStorage.getItem("hh-units") || "metric";
    });

    useEffect(() => {
        window.localStorage.setItem("hh-units", units);
    }, [units]);

    const toggle = () => setUnits((u) => (u === "metric" ? "imperial" : "metric"));

    return (
        <UnitContext.Provider value={{ units, setUnits, toggle }}>
            {children}
        </UnitContext.Provider>
    );
};

export const useUnits = () => {
    const ctx = useContext(UnitContext);
    if (!ctx) throw new Error("useUnits must be used within UnitProvider");
    return ctx;
};
